import React, { useEffect, useState } from "react";
import {
  Loader,
  CommonHeader,
  ErrorSuccessModal,
  DropDown,
  CircularAvatar,
} from "../../components/commons";
import { connect } from "react-redux";
import { RootState } from "../../redux/rootReducers";
import {
  AssignedClientsToUserType,
  ClientType,
  UserType,
} from "../../redux/auth/authTypes";
import { Input } from "reactstrap";
import Select from "react-select";
import {
  getAllClientsAction,
  getAllUserAction,
  resetAuthError,
  resetAuthSuccess,
  resetSession,
  assignClientsToUserAction,
  getAssignedClientsToUserAction,
  getAllFinacUsersAction,
  getAllFinacClientsAction,
  getFinacInternalUsersAction,
  getFinacExternalUsersAction,
} from "../../redux/auth";
import {
  AssignClientsToUserPayloadType,
  GetAllFinacUserPayloadType,
  GetAssignedClientsToUserPayloadType,
  UserPayLoadType,
} from "../../commonTypes/authTypes";
import "./AssignClients.scss";
import useDebounce from "../../customHooks/useDebounce";
import { getClientDirectoryListAction } from "../../redux/clientDirectory";
import { components } from "react-select";

type AppProps = {
  token: string | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  assignedClientsToUserList: AssignedClientsToUserType[] | [];
  dispatchGetAllClientsAction: (data: any) => void;
  dispatchGetFinacInternalUsersAction: (
    data: GetAllFinacUserPayloadType
  ) => void;
  dispatchGetFinacExternalUsersAction: (
    data: GetAllFinacUserPayloadType
  ) => void;
  dispatchAssignClientsToUserAction: (
    data: AssignClientsToUserPayloadType
  ) => void;
  dispatchResetAuthError: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetSession: () => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  finacUserList: any;
  clientList: ClientType[] | [];
  externalUsersList: any;
  internalUsersList: any;
  internalUserCount: string | number;
  externalUserCount: string | number;
  internalFetching: boolean;
  externalFetching: boolean;
};

type clientListType = {
  value: number | undefined;
  label: string | undefined;
};

type userListType = {
  value: number | undefined;
  label: string | undefined;
};

const AssignClients = ({
  token,
  fetching,
  success,
  error,
  statusCode,
  clientList,
  assignedClientsToUserList,
  dispatchGetAllClientsAction,
  dispatchAssignClientsToUserAction,
  dispatchGetAssignedClientsToUserAction,
  dispatchGetFinacInternalUsersAction,
  dispatchResetAuthError,
  dispatchResetAuthSuccess,
  dispatchResetSession,
  finacUserList,
  dispatchGetFinacExternalUsersAction,
  externalUsersList,
  internalUsersList,
  internalUserCount,
  externalUserCount,
  internalFetching,
  externalFetching,
}: AppProps) => {
  const [userId, setUserId] = useState<number | undefined>(undefined);
  const [clientCodeList, setClientCodeList] = useState<number[] | []>([]);
  const [finalClientList, setFinalClientList] = useState<clientListType[] | []>(
    []
  );
  const [finalInternalUserList, setFinalInternalUserList] = useState<
    userListType[] | []
  >([]);
  const [finalExternalUserList, setFinalExternalUserList] = useState<
    userListType[] | []
  >([]);
  const [internalUserSelected, setInternalUserSelected] = useState<any>({
    value: null,
    label: "Select User...",
  });
  const [externalUserSelected, setExternalUserSelected] = useState<any>({
    value: null,
    label: "Select User...",
  });
  const [filteredClientList, setFilteredClientList] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(20);
  const [internalOffset, setInternalOffset] = useState(0);
  const [externalOffset, setExternalOffset] = useState(0);
  const [internalText, setInternalText] = useState("");
  const [externalText, setExternalText] = useState("");
  const [loadCondition, setLoadCondition] = useState(true);
  const [clientTypeName, setClientTypeName] = useState("");
  const [clearInternalSearchText, setClearInternalSearchText] = useState(false);
  const [clearExternalSearchText, setClearExternalSearchText] = useState(false);

  useEffect(() => {
    if (token) {
      if (internalOffset <= +internalUserCount) {
        let finalInternalUserData = {
          token,
          status: 1,
          user_type: "stco_users",
          offset: internalOffset,
          limit,
          search_term: internalText,
        };

        let finalClientData = {
          token,
          status: 1,
        };
        dispatchGetAllClientsAction(finalClientData);
        dispatchGetFinacInternalUsersAction(finalInternalUserData);
      }
      dispatchResetAuthError();
      dispatchResetAuthSuccess();
    }
  }, [internalOffset]);

  useEffect(() => {
    if (token) {
      if (externalOffset <= +externalUserCount) {
        let finalexternalUserData = {
          token,
          status: 1,
          user_type: "external_user",
          offset: externalOffset,
          limit,
          search_term: externalText,
        };
        let finalClientData = {
          token,
          status: 1,
        };
        dispatchGetAllClientsAction(finalClientData);

        dispatchGetFinacExternalUsersAction(finalexternalUserData);
      }
      dispatchResetAuthError();
      dispatchResetAuthSuccess();
    }
  }, [externalOffset]);

  useEffect(() => {
    if (clearInternalSearchText) {
      const finalData = {
        token,
        offset: internalOffset,
        limit,
        user_type: "stco_users",
        status: 1,
        search_term: internalText,
      };
      if (internalText?.length === 0) {
        dispatchGetFinacInternalUsersAction(finalData);
        setInternalOffset(0);
      }
    }
  }, [clearInternalSearchText, internalText]);

  useEffect(() => {
    if (clearExternalSearchText) {
      const finalData = {
        token,
        offset: externalOffset,
        limit,
        user_type: "external_user",
        status: 1,
        search_term: externalText,
      };
      if (externalText?.length === 0) {
        dispatchGetFinacExternalUsersAction(finalData);
        setExternalOffset(0);
      }
    }
  }, [clearExternalSearchText, externalText]);

  const fetchInternalNewData = (search: string) => {
    setClearInternalSearchText(true);
    const finalData = {
      token,
      offset: internalOffset,
      limit,
      user_type: "stco_users",
      status: 1,
      search_term: internalText,
    };
    if (internalOffset === 0) {
      dispatchGetFinacInternalUsersAction(finalData);
    } else {
      setInternalOffset(0);
    }
  };

  const fetchExternalNewData = (search: string) => {
    setClearExternalSearchText(true);
    const finalData = {
      token,
      offset: externalOffset,
      limit,
      user_type: "external_user",
      status: 1,
      search_term: externalText,
    };
    if (externalOffset === 0) {
      dispatchGetFinacExternalUsersAction(finalData);
    } else {
      setExternalOffset(0);
    }
  };

  useDebounce(
    () => {
      if (internalText) {
        fetchInternalNewData(internalText);
      }
    },
    500,
    [internalText]
  );

  useDebounce(
    () => {
      if (externalText) {
        fetchExternalNewData(externalText);
      }
    },
    500,
    [externalText]
  );

  useEffect(() => {
    if (clientList?.length > 0) {
      let finalClientData = clientList?.map((client: ClientType) => {
        return {
          value: client.client_code,
          label: `(${client.client_code}) ${client.company_name}`,
        };
      });
      setFinalClientList(finalClientData);
    }
  }, [clientList]);

  useEffect(() => {
    if (internalUsersList?.length > 0) {
      if (internalOffset <= +internalUserCount) {
        let finalUserData = internalUsersList?.map((user: any) => {
          return {
            value: user.user_id,
            label: `(${user.user_id}) ${user.first_name} ${user.last_name}`,
            first_name: user.first_name,
            last_name: user.last_name,
            image: user.profile_pic?.file_url,
            email: user.email,
            mobile: user.mobile,
            department: user.department,
          };
        });

        if (internalOffset > 0) {
          setFinalInternalUserList([
            ...finalInternalUserList,
            ...finalUserData,
          ]);
        } else {
          setFinalInternalUserList([...finalUserData]);
        }
      }
    }
  }, [internalUsersList]);

  useEffect(() => {
    if (externalUsersList?.length > 0) {
      if (externalOffset <= +externalUserCount) {
        let finalUserData = externalUsersList?.map((user: any) => {
          return {
            value: user.user_id,
            label: `(${user.user_id}) ${user.first_name} ${user.last_name}`,
            first_name: user.first_name,
            last_name: user.last_name,
            image: user.profile_pic?.file_url,
            email: user.email,
            mobile: user.mobile,
            department: user.department,
          };
        });

        if (externalOffset > 0) {
          setFinalExternalUserList([
            ...finalExternalUserList,
            ...finalUserData,
          ]);
        } else {
          setFinalExternalUserList([...finalUserData]);
        }
      }
    }
  }, [externalUsersList]);

  useEffect(() => {
    let alreadyAssignedClients: any[] = [];

    assignedClientsToUserList?.map((client: any) =>
      alreadyAssignedClients?.push(client.client_code)
    );
    setClientCodeList(alreadyAssignedClients);
  }, [assignedClientsToUserList]);

  const renderClientList = () => {
    let clientList =
      searchValue?.length > 0
        ? filteredClientList?.map((client: any) => {
            let assignedCode = clientCodeList.find(
              (oldCode) => oldCode === client.value
            );
            return (
              <li key={client.value}>
                <Input
                  type="checkbox"
                  onChange={() => handleAddClients(client.value)}
                  checked={!!assignedCode}
                />
                {client.label}
              </li>
            );
          })
        : finalClientList?.map((client: any) => {
            let assignedCode = clientCodeList?.find(
              (oldCode) => oldCode === client.value
            );
            return (
              <li key={client.value}>
                <Input
                  type="checkbox"
                  onChange={() => handleAddClients(client.value)}
                  checked={!!assignedCode}
                />
                {client.label}
              </li>
            );
          });

    return clientList;
  };

  const Option = (props: any) => {
    const { data } = props;

    return (
      <components.Option {...props}>
        <div>
          <div className="d-flex justify-content-sm-start">
            <CircularAvatar
              name={data?.first_name + " " + data?.last_name}
              image={data?.image && data?.image}
            />

            <div style={{ marginTop: "-3px", marginLeft: "10px" }}>
              <div></div>
              <span style={{ fontWeight: "500", fontSize: "16px" }}>
                {data?.label}
              </span>
              <br></br>
              <span style={{ color: "#6e7491" }}>
                {data?.mobile?.length > 0 && data?.department?.length > 0 ? (
                  <div>{`${data?.mobile} | ${data?.department}`}</div>
                ) : data?.mobile ? (
                  <div>{data?.mobile}</div>
                ) : (
                  <div>{data?.department}</div>
                )}
              </span>
            </div>
            <div>{`(${data.email})`}</div>
          </div>
        </div>
      </components.Option>
    );
  };

  const filterOptions = (option: any, rawInput: any) => {
    const { label, email, mobile } = option.data;
    return (
      label.toLowerCase().includes(rawInput.toLowerCase()) ||
      email.toLowerCase().includes(rawInput.toLowerCase()) ||
      mobile.toLowerCase().includes(rawInput.toLowerCase())
    );
  };

  const handleChangeExtenalUser = (user: any) => {
    setInternalUserSelected({
      value: null,
      label: "Select User...",
    });
    setSearchValue("");
    setClientTypeName("External Users");
    setExternalUserSelected(user);
    setUserId(undefined);
    setUserId(user?.value);
    if (user && token) {
      let finalData = {
        user_id: user?.value,
        token,
      };
      dispatchGetAssignedClientsToUserAction(finalData);
    }
  };

  const handleChangeInternalUser = (user: any) => {
    setExternalUserSelected({
      value: null,
      label: "Select User...",
    });
    setSearchValue("");
    setClientTypeName("Internal Users");
    setUserId(undefined);
    setInternalUserSelected(user);
    setUserId(user?.value);
    if (user && token) {
      let finalData = {
        user_id: user?.value,
        token,
      };
      dispatchGetAssignedClientsToUserAction(finalData);
    }
  };

  const handleSearchClient = (event: any) => {
    let value = event.target.value;
    if (value?.length > 0) {
      setFilteredClientList([]);
      let searchResult = [...finalClientList];
      searchResult = searchResult?.filter(
        (data: any) =>
          JSON.stringify(data).toLowerCase().search(value.toLowerCase()) !== -1
      );

      setFilteredClientList(searchResult);
      setSearchValue(value);
    } else {
      setSearchValue("");
      getAllClients();
    }
  };

  const getAllClients = () => {
    const finalClientData = {
      token,
      status: 1,
    };
    dispatchGetAllClientsAction(finalClientData);
  };

  const handleAddClients = (clientCode: number) => {
    let oldClientCodeList = [...clientCodeList];
    let newClientCodeList = [];
    let isClientCode = oldClientCodeList?.find(
      (clientCodeId) => clientCodeId === clientCode
    );

    if (isClientCode) {
      newClientCodeList = oldClientCodeList?.filter(
        (code) => code !== clientCode
      );
    } else {
      newClientCodeList = [...oldClientCodeList, clientCode];
    }

    setClientCodeList(newClientCodeList);
  };

  const handleAssignClients = () => {
    setSearchValue("");
    let finalData = {
      user_id: userId,
      client_code: clientCodeList,
      token,
      user_type: clientTypeName === "Internal Users" ? 1 : 2,
    };

    dispatchAssignClientsToUserAction(finalData);
  };

  const handleResetData = () => {
    setInternalUserSelected({
      value: null,
      label: "Select User...",
    });
    setExternalUserSelected({
      value: null,
      label: "Select User...",
    });
    setUserId(undefined);
    setClientTypeName("");
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message="Clients Assigned to Users Successfully!"
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthSuccess();
            handleResetData();
          }}
          statusCode={statusCode}
        />
      );
    }

    return false;
  };
  const checkBottomInternal = (e: any) => {
    setLoadCondition(false);
    setInternalOffset((prv) => prv + limit);
  };
  const checkBottomExternal = (e: any) => {
    setLoadCondition(false);
    setExternalOffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);
  return (
    <div className="row">
      <div className="col-md-12">
        <CommonHeader title="Assign Clients to Users" />
      </div>
      <div className="col-md-5 mt-3">
        <h4 className="mb-3">Choose Internal User</h4>
        <Select
          value={internalUserSelected}
          cacheOptions
          options={finalInternalUserList}
          components={{ Option }}
          filterOption={filterOptions}
          onChange={handleChangeInternalUser}
          onMenuScrollToBottom={(e: any) => checkBottomInternal(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setInternalText(e);
            // setInternalOffset(0);
          }}
          onMenuClose={onMenuClose}
          isLoading={internalFetching}
        />
        <h4 className="mt-3" style={{ textAlign: "center" }}>
          OR
        </h4>
        <h4 className="mb-3">Choose External User</h4>
        <Select
          value={externalUserSelected}
          cacheOptions
          options={finalExternalUserList}
          onChange={handleChangeExtenalUser}
          components={{ Option }}
          onMenuScrollToBottom={(e: any) => checkBottomExternal(e)}
          onInputChange={(e: string) => {
            setLoadCondition(false);
            setExternalText(e);
            // setExternalOffset(0);
          }}
          onMenuClose={onMenuClose}
          isLoading={externalFetching}
          filterOption={filterOptions}
        />
      </div>
      <div className="col-md-7 mt-3">
        <h4 className="mb-3">
          Choose Clients {clientTypeName ? `For ${clientTypeName}` : ""}
        </h4>
        <div className="form-group">
          <div className="d-flex justify-content-start">
            <input
              type="text"
              className="form-control search-client-input w-50"
              placeholder="Search Client..."
              value={searchValue}
              onChange={(e) => handleSearchClient(e)}
              disabled={!userId}
            />
          </div>
        </div>
        <div className="client-container">
          {userId ? (
            <ul className="column-list">{renderClientList()}</ul>
          ) : (
            <span>Please Choose User...</span>
          )}
        </div>
        <button
          className="btn btn-primary mt-4 pointer"
          onClick={handleAssignClients}
          style={{ width: "50%" }}
          disabled={!userId}
        >
          Assign Clients
        </button>
      </div>
      {handleErrorModal()}
      {loadCondition && fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.auth.fetching,
  statusCode: state.auth.statusCode,
  success: state.auth.success,
  error: state.auth.error,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  //   totalUserCount:state.auth.totalUserCount,
  //   finacUserList:state.auth.finacUsersList,
  clientList: state.clientDirectory.clientDirectoryList,
  internalUsersList: state.auth.internalUsersList,
  externalUsersList: state.auth.externalUsersList,
  internalFetching: state.auth.internalFetching,
  externalFetching: state.auth.externalFetching,
  internalUserCount: state.auth.internalUserCount,
  externalUserCount: state.auth.externalUserCount,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetAllClientsAction: (data: any) =>
    dispatch(getClientDirectoryListAction(data)),
  dispatchGetFinacInternalUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getFinacInternalUsersAction(data)),
  dispatchGetFinacExternalUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getFinacExternalUsersAction(data)),
  dispatchAssignClientsToUserAction: (data: AssignClientsToUserPayloadType) =>
    dispatch(assignClientsToUserAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignClients);
